// styles.ts
import { SxProps, Theme } from '@mui/material';

export const drawerWidth = 240;

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
    position: 'fixed',
    width: {
      sm: `calc(100% - ${drawerWidth}px)`,
    },
    ml: {
      sm: `${drawerWidth}px`,
    },
    marginLeft: 240,
  },
  drawer: {
    width: { sm: drawerWidth },
    flexShrink: { sm: 0 },
    '& .MuiDrawer-paper': {
      boxSizing: 'border-box',
      width: drawerWidth,
    },
  },
  main: {
    flexGrow: 1,
    p: 3,
    width: { sm: `calc(100% - ${drawerWidth}px)` },
    marginTop: theme => theme.mixins.toolbar.minHeight,
    marginLeft: 240,
  },
  toolbar: {
    minHeight: theme => theme.mixins.toolbar.minHeight,
  },
};

export default styles;
